import { Guid } from "@/Common/Models/Guid";
import { ContactFacetType } from "@/Common/Models/Individuals/Enums/ContactFacetType";
import { Ethnicities } from "@/Common/Models/Individuals/Enums/Ethnicity";
import { GenderIdentity } from "@/Common/Models/Individuals/Enums/GenderIdentity";
import { PreferredPronouns } from "@/Common/Models/Individuals/Enums/PreferredPronouns";
import { PortalRegistrationState } from "@/Common/Models/Portal/Enums/PortalRegistrationState";

// port of the IndividualLight model
class Individual {
    public Contact_id: Guid;
    public ContactFacetId?: Guid;
    public ContactFacetType?: ContactFacetType;
    public FirstName: string;
    public LastName: string;
    public MotherFirstName: string;
    public DateOfBirth: Date;
    public MiddleName: string;
    public SecondName: string;
    public PreferredName: string;
    public FileNumber: string;
    public NAM: string;
    public MotherLastName: string;
    public FatherFirstName: string;
    public FatherLastName: string;
    public GenderIdentity: GenderIdentity;
    public PreferredSpokenLanguageLookupId: string;
    public PreferredOfficialLanguageLookupId: string;
    public PrefixLookupId: string;
    public GenderLookupId: string;
    public SuffixLookupId: string;
    public PreferredPronouns: PreferredPronouns;
    public SpecifiedPreferredPronouns: string;
    public MaritalStatusLookupId: string;
    public EthnicityKeys: Ethnicities[];
    public FirstNameDSQ: string;
    public NUI: string;
    public LastNameDSQ: string;
    public GenderDSQ: string;
    public LastModifiedMemoEmployeeId: Guid;
    public MemoLastModifiedDate: Date;
    public MemoNote: string;
    public PortalSyncState: PortalRegistrationState;
    public PortalProfileId: string;
    public Religion: string;
    public DoNotEmail: boolean;
    public IsBornPremature: boolean;
    public BornPrematureWeeks?: number;
    public Identifier01: string;
    public IsReadOnly: boolean | null;

    public constructor(init?: Partial<Individual>) {
        Object.assign(this, init);
    }

    public static hasNoDateOfBirthOnFile(individual: Individual): boolean {
        return !individual.DateOfBirth;
    }
}

export { Individual };
